import message from './src/Message.vue'
import Vue from 'vue'

let instance = null
let component = null
let instances = []
let seed = 1
let Message = function(options) {
  const tmp = instances.pop()
  if (tmp) {
    tmp.clearTimer()
    tmp.handleAfterLeave()
  }
  let id = 'message_' + seed++
  component = Vue.extend(message)
  let userOnClose = options.onClose
  instance = new component({ data: options })
  document.body.appendChild(instance.$mount().$el)
  instance.visible = true
  instance.id = id
  instance.onClose = () => {
    close(id, userOnClose)
  }
  let verticalOffset = 135
  instances.forEach(item => {
    verticalOffset += item.$el.offsetHeight + 10
  })
  instance.verticalOffset = verticalOffset
  instances.push(instance)
  return instance
}

function close(id, userOnClose) {
  let length = instances.length
  let index = -1
  for (let i = 0; i < length; i++) {
    if (instances[i].id == id) {
      index = i
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i])
      }
      instances.splice(i, 1)
      break
    }
  }
  length = instances.length
  if (length > 0) {
    const removeHeight = instances[index].$el.offsetHeight
    for (let i = 0; i < length; i++) {
      instances[i].$el.style.top = parseInt(instances[i].$el.style.top) - removeHeight - 10 + 'px'
    }
  }
}

Vue.prototype.$message = options => {
  return new Message(options)
}
Vue.prototype.$warning = Message.$warning = (message, callback = null, duration = 3000) => {
  return new Message({ type: 'warning', message: message, onClose: callback, duration: duration })
}
Vue.prototype.$success = Message.$success = (message, callback = null, duration = 3000) => {
  return new Message({ type: 'success', message: message, onClose: callback, duration: duration })
}
Vue.prototype.$error = Message.$error = (message, callback = null, duration = 3000) => {
  return new Message({ type: 'error', message: message, onClose: callback, duration: duration })
}
export default Message
